// i18n area 'backups' — locale tr-TR (task #171, onda 5): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/backups.tr-TR.meta.json.
import type { enUS } from './backups'

export const trTR: typeof enUS = {
  ckpt: {
    contents: 'Kabul eder',
    contentsHint:
      'Buraya ne inebilir. "Checkpoint\'ler" kümenin yapılandırmasıdır, "Veri yedekleri" sanal makinelerinkidir: iki okuma birleşir, bir hedef ikisini de kabul edebilir.',
    content: { checkpoints: "Checkpoint'ler", backups: 'Veri yedekleri' },
    destinationsTitle: 'Yedek hedefleri',
    checkpointsTitle: 'Checkpointler',
    restoreTitle: 'Geri yükleme',
    addDestination: 'Hedef ekle',
    addDestinationTitle: 'Yedek hedefi ekle',
    editDestinationTitle: 'Hedefi düzenle',
    storage: 'Depolama',
    storageHint:
      'dir benzeri bir depolama (dir/NFS/CIFS/CephFS) — artefaktlar, platform namespace altında sıradan dosyalardır.',
    schedule: 'Zamanlama',
    scheduleNone: 'Yalnızca el ile',
    scheduleHourly: 'Saatlik',
    scheduleDaily: 'Günlük',
    scheduleWeekly: 'Haftalık',
    scheduleHour: 'Saat',
    scheduleWeekday: 'Gün',
    scheduleHint:
      'Zamanlanmış checkpointlerin masterpass yazacak bir operatörü yoktur: keystore gizli değerleri placeholder olarak paketlenir.',
    retention: 'Saklama',
    retentionHint:
      'Kaç zamanlanmış checkpointin tutulacağı — sweeper, sayıyı aşan en eskileri kaldırır. El ile alınan ve geri yükleme öncesi checkpointler asla kaldırılmaz.',
    paused: 'Duraklatıldı',
    pausedHint:
      "Operatörün blackout'u: duraklatma sürdükçe bu hedefte hiçbir şey zamanlanmaz ve hiçbir şey budanmaz — veri policy'leri ve checkpointler eşit biçimde. Süren çalıştırmalara asla dokunulmaz.",
    rescan: 'Artefaktları yeniden benimse',
    orphanRuns: '{n} öksüz çalıştırma',
    orphanRunsHint:
      "Bu hedefte artık var olmayan policy'lerin zamanlanmış çalıştırmaları: hiçbir retention onları yönetmez — asla sayılmaz, asla budanmaz — ve onları yalnızca bir el siler. tvirt diagnose'un „backups“ merceği kaldırılan policy'leri adlandırır.",
    rescanTitle: '{name} artefaktlarının yeniden benimsenmesi',
    rescanHint:
      'Yedek kataloğunu (VM/CT/App) hedefteki artefaktların manifestlerinden yeniden kurar. Mevcut satırlara asla dokunulmaz; bilinmeyen politikaların yedekleri öksüz kalır (asla otomatik budanmaz). Bootstrap geri yüklemesinden sonraki adım.',
    masterpassDrWarning:
      'Felaket senaryosu: LUKS diskleri YALNIZCA masterpass İLE alınmış bir checkpoint’ten geri gelir. Zamanlanmış checkpoint’ler yer tutucular paketler — düzenli olarak masterpass ile manuel checkpoint alın.',
    policy: {
      title: "Veri backup policy'leri",
      hint: "Adlandırılmış policy'ler: hangi nesneler (kind, etiketler, scope'lar), ne sıklıkla, bir çalıştırma ne zaman başlayabilir ve kaç kopya tutulur. Kayıt jesti nesnenin sahibinde kalır: etiketler onun kendi scope'unda atanır.",
      add: 'Policy ekle',
      column: "Veri policy'leri",
      name: 'Ad',
      nameHint:
        "Policy etiketi, hedef içinde benzersiz. Çalıştırmalar policy'nin kararlı id'sini izler: yeniden adlandırmak bedava; silmek çalıştırmalarını öksüz bırakır (artık sayılmaz ve budanmaz).",
      kindLocked: "Mevcut bir policy'nin nesne ailesi değiştirilemez: yeni bir policy oluşturun.",
      kindLabel: 'Nesneler',
      kind: { vm: 'Sanal makineler', ct: 'Konteynerler', app: "App'ler" },
      tags: 'Etiket seçici',
      tagsHint:
        'Virgülle ayrılmış tag=değer çiftleri, AND ile bağlanır. Boş etiketler ve scope\'lar hiçbir şey seçmez — asla "her şey" değil.',
      scopes: "Scope'lar",
      scopesHint: 'Scope yolları (alt ağaçlar), virgülle ayrılır, birbirleriyle OR ile bağlanır.',
      windowStart: 'Pencere başlangıcı',
      windowEnd: 'Pencere sonu',
      windowHint:
        'Yürütme penceresi (HH:MM, yerel saat; sonun ötesindeki bir başlangıç gece yarısını aşar). Yalnızca BAŞLANGICI yönetir: pencereyi taşan bir çalıştırma asla öldürülmez.',
      mode: 'Mod',
      modeHint: "Artımlı, seri ailesinin üstünde gider; kopan bir seri full'a düşer, günlükte söylenir.",
      modeFull: 'Full',
      modeIncremental: 'Artımlı',
      requireQuiesce: 'Quiesce iste (guest agent)',
      paused: 'Policy duraklatıldı',
      retentionNone: 'Her şeyi tut',
      retentionCount: 'Sayı',
      retentionGfs: 'GFS halkaları',
      gfs: { keepLast: 'Sonuncular', daily: 'Günlük', weekly: 'Haftalık', monthly: 'Aylık', yearly: 'Yıllık' },
      gfsHint:
        'Her halka için son N dönemin her birinin en yeni yedeği tutulur. Tutulan bir yedek tüm zincirini canlı tutar — asla öksüzleri olan bir taban kalmaz.',
      lastRun: 'Son çalıştırma',
      neverRan: 'hiç çalıştırılmadı'
    },
    lastCheckpoint: 'Son checkpoint',
    neverRun: 'Hiç oluşturulmadı',
    createNow: 'Checkpoint oluştur',
    createNowTitle: 'Checkpoint oluştur — {name}',
    masterpass: 'Masterpass',
    masterpassHint:
      'Keystore gizli değerlerini korur (değer başına argon2id → AES-256-GCM). Asla saklanmaz: onu kaybetmeyin — onsuz bir geri yükleme, gerçek gizli değerler yerine placeholder üretir.',
    masterpassEmptyHint: 'Gizli değerler yerine açık placeholder paketlemek için boş bırakın.',
    createStarted: 'Checkpoint devam ediyor…',
    destinationInUseError: "'{name}' hâlâ checkpoint içeriyor — önce onları silin.",
    origin: 'Köken',
    originManual: 'el ile',
    originSchedule: 'zamanlanmış',
    originPreRestore: 'geri yükleme öncesi',
    originPreChange: 'değişiklik öncesi',
    preChangeRetention: 'Değişiklik öncesi checkpointler',
    preChangeRetentionHint:
      'Boş = devre dışı. Sessiz bir dönemden sonraki ilk yapılandırma yazımı önceki durumu burada dondurur (köken „değişiklik öncesi“); en yeniler sayıya kadar tutulur — kendi, budanabilir saklaması.',
    diffTitle: 'Değişiklik önizlemesi',
    diffFailed: 'Önizleme başarısız',
    diffRetry: 'Yeniden dene',
    diffCounts: '{changed} değişecek · {missing} oluşturulacak · {extra} fazla · {equal} özdeş',
    diffChanged: 'değişir',
    diffMissing: 'oluşturulurdu',
    diffExtra: 'silinirdi',
    diffJsonb: 'jsonb referansları uygulamadan önce doğrulanamaz',
    diffSecret: 'mühürlü alanlar, karşılaştırılamaz',
    diffMore: '{n} tane daha…',
    diffNeeded: 'Önizleme seçimi yansıttığında başlatma etkinleşir.',
    phase: 'Durum',
    phaseRunning: 'çalışıyor',
    phaseComplete: 'tamamlandı',
    phaseError: 'hata',
    secrets: 'Gizli değerler',
    secretsMasterpass: 'masterpass',
    secretsPlaceholders: 'placeholder',
    size: 'Boyut',
    created: 'Oluşturuldu',
    destination: 'Hedef',
    download: '.tvbk indir',
    deleteCheckpoint: 'Checkpointi sil',
    noCheckpoints: 'Checkpoint yok — bir hedeften bir tane oluşturun.',

    // Round #156: righe di dettaglio del record di archivio.
    families: 'Aileler',
    generation: 'Nesil',
    completedAt: 'Tamamlanma zamanı',
    errorDetail: 'Hata ayrıntısı',
    manifest: 'Manifest',
    restoreHint:
      'Bir .tvbk artefaktı karşıya yükleyin: explorer içinde ne taşıdığını gösterir, sonra neyi nasıl geri yükleyeceğinizi seçersiniz.',
    uploadFile: '.tvbk dosyası karşıya yükle',
    uploading: 'Karşıya yükleniyor…',
    uploadFailed: 'Artefakt açılamadı',
    explorerTitle: 'Checkpoint içeriği',
    checkpointFrom: '{cluster} kümesinin checkpointi, {when} tarihinde oluşturuldu ({origin}, nesil {generation})',
    otherCluster:
      'Bu checkpoint BAŞKA bir kümeden geliyor ({cluster}) — cross-cluster geri yükleme gelecekteki bir round konusu.',
    encrypted: 'şifreli',
    objectsCount: '{n} nesne',
    mode: 'Mod',
    modeMerge: 'Merge — uzlaştırma: seçilen satırlar upsert edilir, hiçbir şey silinmez',
    modeOverwrite:
      'Overwrite — checkpoint kazanır: tamamı seçilmiş bir aile bütün olarak değiştirilir (checkpointte olmayan güncel satırlar kaldırılır)',
    restoreMasterpassHint:
      'Bu checkpointin oluşturulduğu masterpass. Onsuz, şifreli gizli değerler açık placeholder olarak geri yüklenir.',
    checkMasterpass: 'Doğrula',
    masterpassOk: 'Masterpass doğru',
    masterpassWrong: 'Masterpass yanlış',
    parachuteDestination: 'Paraşüt hedefi',
    parachuteHint:
      'Görev, herhangi bir satıra dokunmadan önce buraya otomatik bir geri yükleme öncesi checkpoint oluşturur.',
    summaryTitle: 'Ne olacak',
    summaryLine: '{family}: {what} — {mode}',
    summaryWhole: 'ailenin tamamı',
    summaryObjects: '{n} seçili nesne',
    confirmHint: 'Onaylamak için küme adını ({name}) yazın — geri yükleme, bildirilen yapılandırmayı yeniden yazar.',
    confirmField: 'Küme adı',
    startRestore: 'Geri yükle',
    restoreRunning: 'Geri yükleme devam ediyor…',
    restoreDone: "Geri yükleme tamamlandı — reconciler'lar yeni bildirime yakınsıyor.",
    restoreFailed: 'Geri yükleme başarısız oldu',
    discard: 'At',
    selectionEmpty: 'En az bir aile veya nesne seçin.'
  },

  backup: {
    intro: {
      title: 'VM ve konteyner verilerinin yedeklenmesi',
      subtitle: 'Harici yedekleme yazılımlarının kullandığı yapı taşları',
      whatItIs:
        'TVirt dört temel yapı sunar: quiesced anlık görüntüler, disk başına değişiklik izleme, salt okunur NBD export ve yapılandırma exportu. Bunları Veeam, Bacula, Acronis ve benzerleri yönetir.',
      whatItIsNot:
        'TVirt bir yedekleme ürünü değildir: hiçbir şey zamanlamaz, saklama uygulamaz ve verilerinizin hiçbir arşivini tutmaz. Saklama, kataloglar ve geri yükleme politikaları zaten kullandığınız yazılımda kalır.'
    },
    cbt: {
      title: 'Değişiklik izleme',
      colVm: 'VM',
      colDisk: 'Disk',
      colState: 'Durum',
      colBitmaps: "Bitmap'ler",
      colObservedAt: 'Gözlendi',
      colChangeId: 'Change ID',
      colMechanic: 'Mekanizma',
      stateActive: 'Etkin',
      stateInactive: 'Kapalı',
      stateInconsistent: 'Tutarsız — sonraki yedek tam olmalı',
      stateBroken: 'Zincir kopuk — devre dışı bırakın, sonra yeni zincir olarak etkinleştirin',
      stateSnapshots: 'Her zaman açık — anlık görüntüler arası delta',
      stateUnavailable: 'Bu diskte kullanılamaz',
      mechanic: {
        'qcow2-bitmap': 'qcow2 bitmap',
        'rbd-snapdiff': "Ceph anlık görüntü diff'i",
        'lvm-thin-delta': 'Thin pool deltası',
        none: 'Yok'
      },
      empty:
        "VM diski yok. Değişiklik izleme disk başına okunur: qcow2 diskte etkinleştirin ya da rbd/SAN'da anlık görüntü alın.",
      chainBroken: 'Zincir kopuk',
      chainBrokenText:
        "{reason} tarafından koparıldı: {bitmaps}. Bitmap'i devre dışı bırakın (zincir gitti, sonraki yedek tam), sonra yeni zincir olarak etkinleştirin.",
      lineages: 'Dönemler',
      epochFrozen: '{snapshot} anlık görüntüsünde donduruldu',
      epochLost: 'kayıp ({cause})',
      epochRecording: 'başta kaydediyor',
      milestones: 'Kilometre taşları (anlık görüntüler)',
      enable: 'Değişiklik izlemeyi etkinleştir',
      disable: 'Devre dışı bırak',
      reset: 'Sıfırla',
      changedAreas: 'Değişen alanlar',
      denied: "Bu VM'de izniniz yok",
      enableTitle: 'Değişiklik izlemeyi etkinleştir',
      disableTitle: 'Değişiklik izlemeyi devre dışı bırak',
      resetTitle: "Bitmap'i sıfırla",
      areasTitle: 'Değişen alanlar',
      bitmapName: 'Bitmap adı',
      bitmapNameHint: 'Kendi adınız: tvirt- ve tvbk- platforma aittir',
      granularity: 'Ayrıntı düzeyi (bayt)',
      granularityHint: 'İkinin kuvveti; varsayılan 65536',
      bitmap: 'Bitmap',
      disableHint: "Bitmap'i ve tüm dönem geçmişini kaldırır: sonraki yedek tam olmalı.",
      resetHint: "Bitmap'i boşaltır — yeni bir temel: sıfırlamadan eski bir change ID artık birleştirilemez.",
      areasFrom: 'Anlık görüntüden',
      areasTo: 'Anlık görüntüye',
      areasRun: 'Hesapla',
      areasResult: '{count} değişen alan, {bytes}',
      areasEmpty: 'İki anlık görüntü arasında değişen alan yok',
      areasZero: 'sıfırlar',
      areasMore: '{count} içinden ilk {shown} gösteriliyor',
      submit: 'Onayla',
      error: 'Değişiklik izleme işlemi başarısız'
    },
    exports: {
      title: 'Açık NBD dışa aktarımları',
      colVm: 'VM',
      colDisk: 'Disk',
      colSnapshot: 'Anlık görüntü',
      colBitmap: 'Bitmap',
      colPhase: 'Aşama',
      colNode: 'Düğüm',
      colEndpoint: 'Uç nokta',
      colExpires: 'Sona erer',
      colCreated: 'Açıldı',
      colError: 'Hata',
      phase: {
        preparing: 'Hazırlanıyor',
        ready: 'Hazır',
        closed: 'Kapalı',
        error: 'Başarısız'
      },
      expiresIn: '{minutes} dk içinde',
      expired: 'süresi doldu',
      empty: 'Dışa aktarma yok. Bir okuma oturumu bir diski bir anlık görüntüde bir NBD istemcisine sunar; bir yazma oturumu durdurulmuş bir VM\'nin el değmemiş diskini doldurur. İkisi de süre dolunca ölür.',
      endpointHint: "Küme CA'sı ile TLS; dışa aktarım adı bilettir — oturumla birlikte ölür",
      closeDenied: "Bu VM'nin dışa aktarımlarını kapatma izniniz yok",
      open: 'NBD dışa aktarımı aç',
      openTitle: 'NBD dışa aktarımı aç',
      openDisk: 'Disk',
      openBitmap: 'Bitmap (isteğe bağlı)',
      openBitmapHint:
        "Bu bitmap'in bu anlık görüntüde dondurulmuş dönemini değişen extent'lerin meta-context'i olarak yayımlar (yalnızca qcow2 diskler)",
      openTtl: 'Ömür (dakika)',
      openSubmit: 'Aç',
      openError: 'Dışa aktarım açılamadı',
      colMode: 'Mod',
      mode: {
        read: 'Okuma',
        write: 'Yazma'
      },
      caCertificate: 'Küme CA\'sı',
      caCopy: 'PEM\'i kopyala',
      caDownload: 'ca-cert.pem indir',
      caHint: 'PEM\'i özel bir dizindeki ca-cert.pem dosyasına yazın ve nbds://…?tls-certificates=<dizin> (nbdcopy, nbdinfo) veya --object tls-creds-x509,dir=<dizin>,endpoint=client (qemu-img) ile bağlanın',
      caAbsent: 'Oturum CA taşımıyor (PKI yok)',
      openWrite: 'Yazma dışa aktarması aç',
      openWriteTitle: 'Bir yazma dışa aktarması aç',
      openWriteIntro: 'Disk el değmemiş olmalı: boş doğmuş, hiç yazılmamış, anlık görüntüsüz; VM durdurulmuş. Geri yükleme diski DOLDURUR, onarmaz. Oturum açıkken VM başlamaz, anlık görüntü almaz, klonlanmaz ve disk taşınmaz.',
      openWriteSubmit: 'Aç',
      openWriteError: 'Yazma dışa aktarması açılamadı',
      openWriteDenied: 'Bu VM\'de vm.restore.data izniniz yok',
      openWriteStopped: 'Yazma dışa aktarması açmak için VM\'yi durdurun',
      fromDescription: 'Açıklamadan VM oluştur',
      fromDescriptionTitle: 'Açıklamadan bir VM oluştur',
      fromDescriptionIntro: 'export-vm-meta\'nın açıklaması, açıklanan geometride boş disklere sahip durdurulmuş bir VM olarak geri döner — disk disk yazma dışa aktarmalarına hazır. Baytlar buradan geçmez: onları restore-disk (CLI) veya yedekleme ürününün NBD istemcisi taşır.',
      fromDescriptionDoc: 'Açıklama (JSON)',
      fromDescriptionDocHint: 'export-vm-meta belgesini yapıştırın veya dosyayı seçin',
      fromDescriptionFile: 'Dosya seç…',
      fromDescriptionInvalid: 'Metin bir JSON belgesi değil',
      fromDescriptionName: 'Yeni VM\'nin adı',
      fromDescriptionScope: 'Scope',
      fromDescriptionScopeHome: 'Başlangıç scope\'unuz',
      fromDescriptionStorage: 'Disk depolama',
      fromDescriptionStorageHint: 'Her disk burada, depolamanın varsayılan biçiminde doğar',
      fromDescriptionMetadataStorage: 'Meta veri depolama',
      fromDescriptionSameAsStorage: 'Disklerle aynı',
      fromDescriptionBridge: 'Köprü',
      fromDescriptionBridgeHint: 'Köprü veya ağ olmadan VM ağ kartı olmadan doğar',
      fromDescriptionNetwork: 'Mantıksal ağ (fabric/ağ)',
      fromDescriptionSubmit: 'Oluştur',
      fromDescriptionError: 'VM oluşturulamadı',
      fromDescriptionDone: 'VM oluşturuldu: {name}',
      fromDescriptionOpen: 'VM\'yi aç',
      fromDescriptionDenied: 'vm.create izniniz yok',
      fromDescriptionStillRunning: 'Oluşturma hâlâ sürüyor: beklemeye devam ediliyor'
    },

    // Il MOTORE integrato (#28) — i backup dei dati che TVirt fa davvero.
    vm: {
      title: 'VM veri yedekleri',
      titleOnVm: 'Veri yedekleri',
      empty:
        "Yedek yok. Bir yedek diskleri, UEFI varstore'u ve vTPM durumunu bir hedefe taşır ve sanal makineden sonra da yaşar.",
      colVm: 'VM',
      colCreated: 'Alındığı tarih',
      colPhase: 'Sonuç',
      colDestination: 'Hedef',
      colContains: 'İçerik',
      colSize: 'Boyut',
      colOrigin: 'Köken',
      colMode: 'Tür',
      retentionChip: 'Saklama',
      retentionHint:
        'Hedefin saklama kuralı bu yedeği sormadan silebilir: bir zamanlamadan doğdu. Elle alınan yedekler asla süpürülmez.',
      policyRemoved: 'Policy kaldırıldı: {name}',
      policyRemovedHint:
        "Bu backup'ı zamanlayan policy artık yok: hiçbir retention onu yönetmez (asla otomatik budanmaz) — artık gerekmediğinde elle silin.",
      phase: {
        running: 'Sürüyor',
        complete: 'Tamamlandı',
        error: 'Başarısız'
      },
      origin: {
        manual: 'Elle',
        schedule: 'Zamanlanmış'
      },
      mode: {
        full: 'Tam',
        incremental: 'Artımlı'
      },
      contains: {
        disks: 'Diskler',
        varstore: 'UEFI varstore',
        vtpm: 'vTPM durumu',
        snapshots: 'Anlık görüntüler'
      },
      vmState: {
        stopped: 'VM kapalı',
        running: 'VM çalışıyor (sıcak)'
      },
      artifactClass: { metadata: 'Üstveri', data: 'Veri', secret: 'Sır' },
      detail: {
        tabOverview: 'Özet',
        tabArtefact: 'Artefakt',
        id: 'Tanımlayıcı',
        scope: 'Kapsam',
        vmState: 'Kopyalama anındaki VM durumu',
        pointInTime: 'Verinin anı',
        completedAt: 'Bittiği tarih',
        node: 'Kopyalayan düğüm',
        error: 'Hata',
        path: 'Depolamadaki klasör',
        checksum: 'manifest sha256',
        secretsExposed: 'Hassas materyal açık halde',
        secretsExposedYes: 'Evet — hedef şifrelemiyor',
        secretsExposedNo: 'Hayır',
        baseBackup: 'Temel yedek',
        tabManifest: 'Manifest',
        manifestHint:
          "Artefaktın açık dizini: satır başına bir dosya ve onun sha256'sı. Klasör TVirt olmadan da doğrulanır — qemu-img, tar ve jq yeter.",
        manifestEmpty: 'Manifest hiçbir dosya listelemiyor.',
        manifestError: 'Manifest okunamıyor',
        colEntry: 'Dosya',
        colClass: 'Sınıf',
        colSha: 'sha256'
      },
      create: {
        action: 'Şimdi yedekle',
        title: 'Şimdi yedekle',
        submit: 'Yedeklemeyi başlat',
        destination: 'Hedef',
        destinationHint: 'Yalnızca yedekleri kabul eden hedefler.',
        noDestinations: 'Hiçbir hedef yedek kabul etmiyor: Sistem → Checkpoints altında bir tane oluşturun.',
        contentsHint:
          'Bütün diskler, UEFI varstore ve vTPM durumu yola çıkar. Son ikisi asıl meseledir: mühürlü bir konuk yeniden açılabilmelidir.',
        error: 'Yedekleme başlamadı',
        stillRunning: 'Yedekleme hâlâ sürüyor — pencereyi kapatsanız da kopyalama devam eder.',
        vmRunning:
          'Makine {phase}: yedek, oturmuş bir VM ister — soğuk kopya için kapalı, sıcak kopya için çalışır durumda.'
      },
      restore: {
        action: 'Geri yükle',
        title: 'Geri yükle',
        intro:
          'Geri yükleme geri alınamaz. Verinin nereye döneceğini seçin: yeni bir makineye ya da geldiği makinenin üzerine.',
        modeNewVm: "YENİ bir VM'e geri yükle",
        modeNewVmHint:
          'Var olan hiçbir şeye dokunmaz — bir yedeği bununla doğrularsınız. Yeni tanımlayıcı ve yeni basılmış MAC adresleri.',
        modeOver: "Geldiği VM'in üzerine yaz",
        modeOverHint: "Hedef VM'in şu anki verisini geri dönüşü olmadan yok eder. Makine kapalı olmalıdır.",
        newName: "Yeni VM'in adı",
        newNameHint: 'Hedef kapsamda boş olmalıdır.',
        storage: 'Disklerin depolaması',
        storageHint: 'Zorunlu: manifest bir diskin boyutunu ve biçimini kaydeder, üzerinde durduğu depolamayı asla.',
        metadataStorage: 'Varstore ve vTPM depolaması',
        metadataStorageHint: 'UEFI kimliğinin ve vTPM durumunun ineceği yer.',
        sameAsStorage: 'Disklerle aynı',
        bridge: "Host bridge'i",
        bridgeHint:
          'Kaydedilmiş her ağ kartı bu bridge üzerinde yeni bir MAC ile geri döner. Boş bırakılırsa VM kartsız doğar — daha güvenli olan varsayılan.',
        overwriteTitle: "Bu VM'in üzerine yazmak üzeresiniz",
        overwriteName: 'Ad',
        overwriteId: 'Tanımlayıcı',
        overwriteDisks: 'Üzerine yazılacak diskler',
        overwriteNoDisks: 'Disk yok.',
        overwriteKeeps:
          "Tanımlayıcı, ad, kapsam, ağ kartları ve MAC adresleri dokunulmadan kalır: yedek VERİDİR, yapılandırma checkpoint'tir.",
        confirmField: "VM'in adı",
        confirmHint: 'Onaylamak için {name} yazın.',
        targetLoading: 'Hedef VM okunuyor…',
        targetRunning:
          'Hedef VM {phase}: geri yükleme konuğun altındaki baytları yeniden yazar, bu yüzden onu kapalı ister.',
        targetGone: "Kaynak VM artık okunamıyor: yeni bir VM'e geri yükleme seçeneği duruyor.",
        onlyComplete: 'Yedek {phase}: yalnızca tamamlanmış bir yedek geri yükleyebilir.',
        submitNewVm: "Yeni VM'e geri yükle",
        submitOver: 'Üzerine yaz',
        error: 'Geri yükleme başlamadı',
        stillRunning: 'Geri yükleme hâlâ sürüyor — bütün diskleri kopyalamak zaman alır.'
      }
    },
    guest: {
      title: {
        ct: 'Konteynerlerin veri yedekleri',
        app: "App'lerin veri yedekleri"
      },
      tabTitle: 'Yedekler',
      empty: 'Yedek yok. Bir yedek kalıcı verileri bir hedefe taşır ve nesnesinden uzun yaşar.',
      colSubject: {
        ct: 'Konteyner',
        app: 'App'
      },
      colCreated: 'Alındı',
      colPhase: 'Sonuç',
      colDestination: 'Hedef',
      colContains: 'İçerik',
      colSize: 'Boyut',
      colOrigin: 'Köken',
      policyRemoved: 'Policy kaldırıldı: {name}',
      policyRemovedHint:
        "Bu backup'ı zamanlayan policy artık yok: hiçbir retention onu yönetmez (asla otomatik budanmaz) — artık gerekmediğinde elle silin.",
      phase: {
        running: 'Sürüyor',
        complete: 'Tamamlandı',
        error: 'Başarısız'
      },
      origin: {
        manual: 'Elle',
        schedule: 'Zamanlanmış'
      },
      state: {
        stopped: 'Nesne durdurulmuş',
        running: 'Nesne çalışıyor (dondurulmuş)'
      },
      contains: {
        rootfs: 'Rootfs ağacı',
        config: 'Yapılandırma',
        volumes: 'Kalıcı birimler',
        root: 'Kalıcı root'
      },
      artifactClass: {
        metadata: 'Üstveri',
        data: 'Veri',
        secret: 'Gizli'
      },
      create: {
        action: 'Şimdi yedekle',
        title: 'Yeni yedek',
        submit: 'Yedeği başlat',
        error: 'Yedek başlamadı',
        destination: 'Hedef',
        destinationHint: 'Yalnızca veri yedeklerini kabul eden hedefler.',
        noDestinations: 'Hiçbir hedef veri yedeklerini kabul etmiyor: bir hedefe “Veri yedekleri” ekleyin.',
        hint: {
          ct: "Tüm rootfs ağacı sadakatle yolculuk eder (sayısal sahipler, xattr'lar, ACL'ler), artı manifestteki beyan edilmiş yapılandırma. Çalışan bir konteyner paketleme boyunca DONDURULUR: crash-consistent kopya, beyan edilmiş.",
          app: 'YALNIZCA kalıcı birimler (ve kalıcı root) yolculuk eder, artı manifestteki yapılandırma. Geçici olanlar onaylamayla dışlanmıştır ve manifest onları adlandırır; gizli beyan edilen env değerleri yolculuk etmez.'
        },
        stillRunning: 'Yedek hâlâ sürüyor — bütün ağaçları paketlemek zaman alır.'
      },
      detail: {
        tabOverview: 'Genel bakış',
        tabManifest: 'Manifest',
        id: 'Tanımlayıcı',
        scope: 'Kapsam',
        state: 'Kopyalama anındaki durum',
        pointInTime: 'Şu andaki veriler',
        completedAt: 'Sonuçlandı',
        node: 'Kopyalayan düğüm',
        error: 'Hata',
        path: 'Depolamadaki dizin',
        checksum: 'manifest sha256',
        manifestHint:
          "Artefaktın dizini: her dosya için sha256'sıyla bir kayıt — hash'ler olmadan “yedek orada” bir inanç eylemidir.",
        manifestError: 'Manifest okunamıyor',
        manifestEmpty: 'Manifestte artefakt yok.',
        colEntry: 'Dosya',
        colClass: 'Sınıf',
        colSha: 'sha256',
        excluded: 'Onaylamayla dışlandı (yolculuk etmez)',
        secretKeys: 'Atlanan gizli env anahtarları (#307) — geri yüklemeden sonra yeniden girin'
      },
      restore: {
        action: 'Geri yükle',
        title: 'Geri yükleme',
        submit: 'Geri yükle',
        error: 'Geri yükleme başlamadı',
        stillRunning: 'Geri yükleme hâlâ sürüyor — bütün ağaçları açmak zaman alır.',
        onlyComplete: 'Yedek {phase}: yalnızca tamamlanmış bir yedek geri yükleyebilir.',
        asNew: {
          ct: 'YENİ bir konteynere — hiçbir şeyi yok etmez: bir yedeğin doğrulandığı jest',
          app: "YENİ bir App'e — hiçbir şeyi yok etmez: bir yedeğin doğrulandığı jest"
        },
        over: {
          ct: 'Kaynak konteynerin ÜZERİNE — tüm rootfs ağacı değiştirilir',
          app: "Kaynak App'in ÜZERİNE — her kalıcı birimin içeriği değiştirilir"
        },
        name: 'Yeni nesnenin adı',
        storage: 'Depolama',
        storageHint: "Geri yüklenen verilerin indiği yer — manifest kaybolan pool'u asla kaydetmez.",
        storageDeclared: 'Manifestte beyan edilen depolamalar',
        bridge: 'Ana makine köprüsü',
        bridgeHint:
          'Kayıtlı her kart bu köprüye taze bir MAC ile döner. Boş = bağlantısız doğar, en güvenli varsayılan.',
        node: 'Düğüm',
        nodeHint: "App'in yeniden doğduğu üye: düğüm küme kimliğidir ve asla manifestten gelmez.",
        secretKeysWarning:
          'Gizli beyan edilen env değerleri yedekte yolculuk etmez: yeniden doğan kopya onları yeniden girilmiş ister (task günlüğü anahtarları adlandırır).',
        overInventory: 'Bu nesnenin üzerine yazmak üzeresiniz',
        confirmType: 'Onaylamak için {name} yazın',
        targetGone: 'Kaynak nesne artık okunamıyor: yeni olarak geri yükleme hâlâ mümkün.',
        targetLoading: 'Hedef nesne okunuyor…',
        targetRunning:
          'Hedef nesne çalışıyor: geri yükleme konuğun altındaki baytları değiştirir, bu yüzden onu durdurulmuş ister.'
      }
    }
  }
}
